var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { AccountApiService } from '../../../../services/account.api.service';
import { SetContactsModalData } from './set.contacts.modal.provider';
import { AlertifyService } from '../../../../services/alertify.service';
var SetContactsModalComponent = /** @class */ (function (_super) {
    __extends(SetContactsModalComponent, _super);
    function SetContactsModalComponent(fb, accountApiService, alertify, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.dialogRef = dialogRef;
        _this.account = Object.assign({}, data);
        _this.contact = _this.account.account.contacts;
        return _this;
    }
    SetContactsModalComponent.prototype.ngOnInit = function () {
        this.hubContactsForm = this.fb.group({
            name: [null, [Validators.required]],
            number: [null],
            email: [null, [Validators.required]],
            inquiryEmail: [null, null],
            event: [null, null],
            place: [null, null],
            tour: [null, null],
        });
        this.placeForm = this.fb.group({
            dynamicFields: this.fb.array([]),
        });
        for (var _i = 0, _a = this.contact.placeURLs; _i < _a.length; _i++) {
            var url = _a[_i];
            this.addPlaceURL(url.igURL, url.clientURL);
        }
    };
    SetContactsModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    SetContactsModalComponent.prototype.save = function (event) {
        var _this = this;
        var array = this.placeForm.get('dynamicFields');
        console.log(array);
        var urls = array.value.filter(function (x) { return x.igURL && x.clientURL; });
        var igDegaulePlaceCategories = [
            'All',
            'Accommodations',
            'Activities',
            'Arts & Culture',
            'Dining & Nightlife',
            'Entertainment',
            'Outdoors',
            'Wellness',
            'Shopping',
            'Transportation',
            'Other',
        ];
        var _loop_1 = function (url) {
            var regex = /\/places\/(\w+)\/custom/;
            var match = url.igURL.match(regex);
            if (!match && !igDegaulePlaceCategories.any(function (x) { return x === url.igURL; })) {
                this_1.alertify.warning("ImGoing place URL must be ImGoing's default place category (\n            " + igDegaulePlaceCategories.join(', ') + "). \n            <br/><br/>Or custom category in this format: /" + this_1.account.account.userName + "/places/664b3fdcbf671088a01a8322/custom", 10);
                setTimeout(function () {
                    var msgbox = document.querySelector('.ajs-message');
                    if (msgbox) {
                        msgbox.style.width = '450px';
                        msgbox.style.right = '490px';
                    }
                });
                event.immediateComplete();
                return { value: void 0 };
            }
        };
        var this_1 = this;
        for (var _i = 0, urls_1 = urls; _i < urls_1.length; _i++) {
            var url = urls_1[_i];
            var state_1 = _loop_1(url);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        this.contact.placeURLs = urls;
        this.accountApiService
            .setContacts(this.account.account._id, this.contact)
            .finally(event.complete)
            .subscribe(function (data) {
            _this.success.success();
            setTimeout(function () {
                _this.dialogRef.close();
            }, 2000);
        });
    };
    SetContactsModalComponent.prototype.addPlaceURL = function (igURL, clientURL) {
        if (igURL === void 0) { igURL = ''; }
        if (clientURL === void 0) { clientURL = ''; }
        var newGroup = this.fb.group({
            igURL: [igURL],
            clientURL: [clientURL],
        });
        this.placeForm.get('dynamicFields').push(newGroup);
    };
    SetContactsModalComponent.prototype.getControls = function () {
        var field = this.placeForm.get('dynamicFields');
        if (field) {
            return field.controls;
        }
        return [];
    };
    return SetContactsModalComponent;
}(BaseComponent));
export { SetContactsModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.contacts/set.contacts.modal.component.ts.pre-build-optimizer.js